import { useEffect, useRef, useState } from "react";
import { STATS } from "../mock";

function StatCard({ value, label, index }) {
  return (
    <div
      className="reveal group relative overflow-hidden rounded-2xl border border-teal-500/12 bg-gradient-to-b from-white/[0.05] to-transparent p-8 transition-all hover:border-teal-400/30"
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-teal-500/10 blur-2xl opacity-0 transition-opacity group-hover:opacity-100" />
      <p className="font-display font-extrabold text-4xl lg:text-5xl text-gradient-teal">{value}</p>
      <div className="mt-4 h-px w-12 bg-teal-400/40" />
      <p className="mt-4 text-slate-300 font-medium">{label}</p>
    </div>
  );
}

export default function Stats() {
  return (
    <section className="relative py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid sm:grid-cols-3 gap-5">
          {STATS.map((s, i) => (
            <StatCard key={i} value={s.value} label={s.label} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}